var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`bap_portal_overlay-root ${_vm.active && 'active'}`},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bap_portal_overlay-spinner"},[_c('i',{staticClass:"fa fa-spinner fa-spin inner-loading"})])
}]

export { render, staticRenderFns }